import edpTheme from 'pages/themes/edpTheme';

export const AVAILABLE_LOCALES = {
    ptPT: 'pt-PT',
    enGB: 'en-GB',
};

export const AVAILABLE_LANGUAGES = [
    {
        languageId: 'portuguese',
        locale: AVAILABLE_LOCALES.ptPT,
        appLocale: AVAILABLE_LOCALES.ptPT,
        localePickers: 'pt',
        name: 'label.portuguese',
        icon: 'pt',
        flagIcon: `assets/images/icons/svg/flags/pt.svg`,
    },
    {
        languageId: 'english',
        locale: AVAILABLE_LOCALES.enGB,
        appLocale: AVAILABLE_LOCALES.enGB,
        localePickers: 'en-gb',
        name: 'label.english',
        icon: 'en',
        flagIcon: `assets/images/icons/svg/flags/gb.svg`,
    },
];

export const DEFAULT_LOCALE = AVAILABLE_LANGUAGES[0]; // Portuguese (pt-PT) as default

// * DEFAULT OBJECTS * \\
export const INITIAL_USER = {
    id: 0,
    name: '',
    username: '',
    profile_id: 0,
    user_type_id: 0,
    user_group_id: 0,
    language: null,
    auth: {
        isRequesting: false,
        isUserAuthenticated: false,
        showPassword: false,
    },
    locale: DEFAULT_LOCALE,
    currency: {
        description: 'Euro',
        code: 'EUR',
        symbol: '€',
        sub_unit_description: 'cent',
        sub_unit_symbol: 'c',
    },
    company_id: 0,
    changed_pass: false,
    active: false,
    is_demo: false,
    channel_id: 0,
    partner_id: 0,
    supervisor_id: null,
    user_management: false,
    has_housing_with_panels: false,
    has_audit_files: false,
    show_form: false,
    has_lecs: false,
    product_ids_permitted: null,
    files_permitted: null,
    has_editable_docs: false,
    companyName: '',
    user_type: '',
    channel: '',
    partner: '',
    supervisor: '',
    sales_point: '',
    email: '',
};

export const EXT_FIELD = {
    PHONE: '(+351)',
    CPE: 'PT0002',
};

// * CONSTANTS * \\
export const USERS_TYPE_ID = {
    MANAGER: 1, //PLATFORM
    SUPERVISOR: 2, //PLATFORM
    AGENT: 3, //PLATFORM
    CHANNEL: 4, //PLATFORM
    CLIENT: 5, //PLATFORM
};

export const USER_COMPANY_IDS = {
    EDP_PT: 1,
    EDP_ES: 2,
    CEZ: 3,
    CLP: 4,
    ESB: 5,
    EDP_IT: 6,
    DEMO: 7,
    EDP_PL: 8,
    EDP_BR: 9,
};

export const AVAILABLE_COMPANIES = [
    {
        id: USER_COMPANY_IDS.EDP_PT,
        name: 'EDP',
        theme: edpTheme,
        usePoweredBy: true,
    },
];

export const USER_GROUP_IDS = {
    STANDARD: 1, //Auto Consumo (SELF_CONSUMPTION)
    MANAGER: 2, //SELF_CONSUMPTION & LECs
};
